//import React from 'react';
// First: every admin API request carries the login (and a rejected login logs out).
import './apiAuth';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// After App, so its small-screen fixes win over the pages' own styles.
import './styles/Responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
